// extracted by mini-css-extract-plugin
export default {"field":"Constellation_field__fRCkL","mark":"Constellation_mark__FiPJS","twinkle":"Constellation_twinkle__JE1JX"};